import _styled from "styled-components";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import styled from "styled-components";
import Box from "../../Styled/Box";
import { SpacingSpan } from "../../Styled/Spacing";
import { TextSpan } from "../../Styled/Text";
import { RawButton } from "../../Styled/Button";

// only spans are valid html for buttons (even though divs work)
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const ButtonWrapper = styled(Box).attrs({
  as: "span"
}).withConfig({
  displayName: "WorkbenchButton__ButtonWrapper",
  componentId: "sc-1hm60fi-0"
})(["display:flex;justify-content:center;align-items:center;"]);
// styles half ripped from nav.scss
const StyledWorkbenchButton = styled(RawButton).withConfig({
  displayName: "WorkbenchButton__StyledWorkbenchButton",
  componentId: "sc-1hm60fi-1"
})(["border-radius:3px;background:", ";color:", ";flex-grow:1;height:32px;min-width:32px;box-shadow:none;svg{height:16px;width:16px;fill:", ";}&:hover,&:focus{background:", ";}", " ", " ", ""], props => props.theme.darkLighter, props => props.theme.textLight, props => props.theme.textLight, props => props.theme.colorPrimary, props => props.disabled && "\n    opacity:0.5;\n    // background: ".concat(props.theme.textDarker, ";\n    &:hover,\n    &:focus {\n      cursor: not-allowed;\n      background: ").concat(props.theme.dark, ";\n    }\n    "), props => props.primary && "\n    background: ".concat(props.theme.colorPrimary, ";A\n    color: ").concat(props.theme.textLight, ";\n    svg {\n      fill: ").concat(props.theme.textLight, ";\n    }\n  "), props => props.inverted && "\n    background: ".concat(props.theme.textDarker, ";\n    color: ").concat(props.theme.textLight, ";\n    svg {\n      fill: ").concat(props.theme.textLight, ";\n    }\n  "));
const WorkbenchButton = props => {
  const {
    children,
    title,
    primary,
    inverted,
    disabled,
    iconOnly
  } = props;
  return /*#__PURE__*/_jsx(StyledWorkbenchButton, _objectSpread(_objectSpread({
    primary: primary,
    disabled: disabled,
    iconOnly: iconOnly,
    inverted: inverted,
    type: "button",
    title: title,
    onClick: props.onClick
  }, props), {}, {
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [props.iconElement && props.iconElement(), children && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SpacingSpan, {
          right: 1
        }), /*#__PURE__*/_jsx(_StyledTextSpan, {
          noWrap: true,
          small: true,
          children: children
        })]
      })]
    })
  }));
};
export default WorkbenchButton;
var _StyledTextSpan = styled(TextSpan).withConfig({
  displayName: "WorkbenchButton___StyledTextSpan",
  componentId: "sc-1hm60fi-2"
})(["display:block;text-transform:uppercase;letter-spacing:0.08px;"]);